import { useCurrencyRateAmount } from '../../hooks/event-store-hooks.tsx';

/**
 * Get currency rate by currency code id
 * @param currencyCodeId
 */
export const useCurrencyRate = (currencyCodeId: string) => {
  const { data: rateData, loading: loadingRateData } = useCurrencyRateAmount({
    currencyCode: currencyCodeId,
  });

  const csprCurrencyRate = rateData?.data?.amount;

  return {
    loadingRateData: loadingRateData,
    csprCurrencyRate: csprCurrencyRate,
  };
};
